// app/src/lib/scale/team.js — team membership client (owner manages; invitee accepts).

import { getAccessToken } from '../auth/cognitoClient.js';
import { getConfig } from '../config.js';

async function api(path, { method = 'GET', body } = {}) {
  const at = await getAccessToken();
  if (!at) throw new Error('team: not signed in');
  const res = await fetch(`${getConfig().apiBaseUrl}${path}`, {
    method,
    headers: { authorization: `Bearer ${at}`, ...(body ? { 'content-type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const e = new Error(`team ${res.status}`);
    e.status = res.status;
    try { e.body = await res.json(); } catch { /* non-JSON */ }
    throw e;
  }
  return res.json();
}

/** Owner: { seats:{used,limit}, members:[…], invites:[…] }. */
export const listTeam = () => api('/team');
/** Owner: invite an email as a read-only viewer. */
export const invite = (email) => api('/team/invites', { method: 'POST', body: { email } });
/** Owner: revoke a pending invitation. */
export const revokeInvite = (invitationId) => api(`/team/invites/${encodeURIComponent(invitationId)}`, { method: 'DELETE' });
/** Invitee: bind to the account named by the invitation. */
export const acceptInvite = (invitationId, token) => api('/team/accept', { method: 'POST', body: { invitationId, token } });
/** Invitee: auto-claim a pending invite matching the signed-in (verified) email. Returns {claimed}. */
export const claimInvite = () => api('/team/claim', { method: 'POST' });
/** Owner: remove a member (also deletes their Cognito user). */
export const removeMember = (memberSub) => api(`/team/members/${encodeURIComponent(memberSub)}`, { method: 'DELETE' });
